module.exports = __webpack_public_path__ + "img/circle-exclamation.390134c3.svg";